module.exports = __webpack_public_path__ + "static/media/img-4.5e9450a1.jpg";